// Single Brand
export const RESET_DATA = "RESET_DATA";
export const GET_BRAND_DETAILS = "GET_BRAND_DETAILS";
export const START_LOADING_BRAND = "START_LOADING_BRAND";
export const STOP_LOADING_BRAND = "STOP_LOADING_BRAND";
export const ERROR_LOADING_BRAND = "ERROR_LOADING_BRAND";